<template>
    <div>
        <headerNav title="红包雨" />
        <div @click.stop="setshow()">
            <img class="bgimg" src="http://mcpic.ypunai.com//qyh/H5/m23.gif" >
        </div>
        <div @click.stop="gosee" class="fztop">
            查看记录<span style="font-size:15px;"> ></span>
        </div>
        <!-- <div class="fcen"> 
            <img class="fcenimg" src="../../assets/zqpic/fmm3.jpg">
            <div class="gbtnimg">

            </div>
        </div> -->
        <div class="fshowimg" v-show="fshow" @click="fshow=false">
             <img  src="http://mcpic.ypunai.com//qyh/H5/fimg.png"  />
             <div class="fwz">
                 {{fmoney}}
             </div>
        </div>
        <div class="fshowimg" v-show="fzshow" @click.stop="startdraw()">
             <img  src="http://mcpic.ypunai.com//qyh/H5/x3.png"  />
        </div>
        <div class="zzcf" v-if="ftimeshow">
            <div class="zzcfinfo">
                <div class="zzcfinfo-wz">{{msg}}</div>
                <van-count-down :time="alltime" @finish="finish" v-if="alltime>0">
                    <template #default="timeData">
                        <span class="block">{{ timeData.days }}天</span>
                        <span class="block">{{ timeData.hours }}时</span>
                        <!-- <span class="colon">:</span> -->
                        <span class="block">{{ timeData.minutes }}分</span>
                        <!-- <span class="colon">:</span> --> 
                        <span class="block">{{ timeData.seconds }}秒</span>
                    </template>
                </van-count-down>
            </div> 
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            redpaper:undefined,
            fmoney:0,
            fshow:false,
            alltime:0,
            msg:'',
            ftimeshow:true,
            personinfo:undefined,
            fzshow:false
        }
    },
    created(){
        //活动还未开始 黑屏
        this.queryinfo();
    },
    methods:{
        queryinfo(){
            this.ajax.post('/api/services/app/PhoneRedPaper/QueryRedPaperAllInfoDto').then(x=>{
                this.redpaper=x.result.redPaperDto;
                this.personinfo=x.result.redPaperYetDraw;
                this.settimer();
            })
        },
        gosee()
        {
            this.$router.push({path:'/RedPaperPerson'});
        },
        finish()
        {
            this.queryinfo();
        },
        setshow(){
            if(this.fshow)
            {
                this.fshow=false;
            }else
            {
                if((this.personinfo.limitNum-this.personinfo.yetDrawNum)<1)
                {
                    this.$toast("您的红包已经发过了");
                    return ;
                }
                this.fzshow=true;
            }
        },
        startdraw(){
            if(this.fshow)
            {
                this.fshow=false;
                return;
            }
            if(this.fzshow)
            {
                this.fzshow=false;
            }
            if(!this.personinfo)
            {
                this.$toast("暂无进行中的活动");
                return ;
            }
            if((this.personinfo.limitNum-this.personinfo.yetDrawNum)<1)
            {
                this.$toast("您的红包已经发过了");
                return ;
            }
            //判断人的情况
            //开始抽奖
            this.ajax.post('/api/services/app/PhoneRedPaper/StartDraw?redPaperId='+this.redpaper.id).then(x=>{
                  this.fmoney=x.result.money;
                  this.fshow=true;
                  if(this.personinfo)
                  {
                      this.personinfo.yetDrawNum+=1;
                  }
            })
        },
        //判断活动开始
        //判断快到哪个节点
        settimer()
        {
            this.alltime=0;
            this.ftimeshow=true;
            this.msg="";
            if(this.redpaper)
            {
                if(this.redpaper.timeType==0)
                {
                    this.msg="活动未开始";
                    //距离活动开始时间
                    this.alltime=new Date(this.setmtime(this.redpaper.startTime)).getTime()-Date.now();
                }
                if(this.redpaper.timeType==-90)
                {
                    this.msg="活动已经结束";
                }
                if(this.redpaper.timeType==2)
                {
                    if(!this.redpaper.nearRedPaperDetailId)
                    {
                        this.msg="今日红包雨已经全部结束";
                    }
                    if(this.redpaper.nearRedPaperDetailId)
                    {
                        var fdetail= this.redpaper.redPaperDetailList.filter(x=>x.id==this.redpaper.nearRedPaperDetailId)[0];
                        this.msg="距离下一个红包雨";
                        this.alltime=(new Date(this.setmtime(fdetail.realStartTime)).getTime()+1000*3)-Date.now();
                        console.log(this.alltime);
                    }
                }
                if(this.redpaper.timeType==3)
                {
                    this.ftimeshow=false;
                }

            }else
            {
                this.msg="暂无进行中的活动";
            }
            console.log(this.msg);
        },
        setmtime(vtimer){
			return vtimer.replace(/\-/g, '/');
		},
    }
}
</script>
<style lang="scss" scoped>
.bgimg{
    width: 100%;
    height: auto;
}
.fshowimg{
    position: fixed;
    top:50%;
    left: 15%;
    right: 15%;
    text-align: center;
    transform: translateY(-50%);
    img{
        width: 100%;
        border-radius: 10px;
    }
    .fwz{
        font-size: 50px;
        position: absolute;
        left: 0;
        right: 0;
        top: 340px;
        color: #921606;
        font-weight: bold;
    }
}
.fcen{
    position: fixed;
    top:50%;
    text-align: center;
    transform: translateY(-50%);
    img{
        width: 60%;
    }

}

.zzcf{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #000000a6;
    text-align: center;
    .zzcfinfo{
        position: fixed;
        top: 50%;
        left: 0;
        right: 0;
        transform: translateY(-50%);
        text-align: center;
        .zzcfinfo-wz{
            font-size: 20px;
            color:white;
            margin-bottom: 20px;
        }
    }
}
.colon {
    display: inline-block;
    margin: 0 4px;
    color: #ee0a24;
}
.block {
    display: inline-block;
    color: #fff;
    font-size: 36px;
    text-align: center;
    color:red;
}
.fztop{
    position: fixed;
    top: 60px;
    right: 10px;
    z-index: 999;
    color:#d5071a;
    font-size: 14px;
}
</style>
